async function requestJson(path, options = {}) {
  const response = await fetch(path, {
    credentials: "include",
    headers: {
      Accept: "application/json",
      ...(options.body ? { "Content-Type": "application/json" } : {}),
    },
    ...options,
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    const err = new Error(data.message || `Request failed (${response.status})`);
    throw err;
  }
  return data;
}

export async function fetchVehicleNormalizationIssues(filters = {}) {
  const params = new URLSearchParams();
  if (filters.fieldName) params.set("field_name", filters.fieldName);
  if (filters.issueType) params.set("issue_type", filters.issueType);
  if (filters.status) params.set("status", filters.status);
  if (filters.vehicleSourceId) params.set("vehicle_source_id", filters.vehicleSourceId);
  if (filters.minConfidence != null) params.set("min_confidence", String(filters.minConfidence));
  if (filters.maxConfidence != null) params.set("max_confidence", String(filters.maxConfidence));
  if (filters.createdFrom) params.set("created_from", filters.createdFrom);
  if (filters.createdTo) params.set("created_to", filters.createdTo);
  if (filters.make) params.set("make", filters.make);
  if (filters.model) params.set("model", filters.model);
  if (filters.search) params.set("search", filters.search);
  if (filters.limit) params.set("limit", String(filters.limit));
  if (filters.issueCategory) params.set("issue_category", filters.issueCategory);
  if (filters.severity) params.set("severity", filters.severity);
  if (filters.autoCorrected != null) params.set("auto_corrected", String(filters.autoCorrected));
  const query = params.toString();
  const data = await requestJson(
    `/api/admin/mobility/vehicle-normalization-issues${query ? `?${query}` : ""}`
  );
  return { issues: data.issues || [], summary: data.summary || {} };
}

export async function patchVehicleNormalizationIssue(id, payload) {
  return requestJson(`/api/admin/mobility/vehicle-normalization-issues/${encodeURIComponent(id)}`, {
    method: "PATCH",
    body: JSON.stringify(payload),
  });
}

export async function createAliasFromIssue(id, payload) {
  return requestJson(
    `/api/admin/mobility/vehicle-normalization-issues/${encodeURIComponent(id)}/create-alias`,
    { method: "POST", body: JSON.stringify(payload) }
  );
}

export async function fetchIdentityReviewDetail(id) {
  const data = await requestJson(
    `/api/admin/mobility/vehicle-normalization-issues/${encodeURIComponent(id)}/identity-review`
  );
  return data;
}

export async function approveIdentityReviewIssue(id, payload) {
  return requestJson(
    `/api/admin/mobility/vehicle-normalization-issues/${encodeURIComponent(id)}/approve-identity`,
    { method: "POST", body: JSON.stringify(payload) }
  );
}

export async function dismissIdentityReviewIssue(id, payload) {
  return requestJson(
    `/api/admin/mobility/vehicle-normalization-issues/${encodeURIComponent(id)}/dismiss-identity`,
    { method: "POST", body: JSON.stringify(payload) }
  );
}

export async function correctIdentityReviewIssue(id, payload) {
  return requestJson(
    `/api/admin/mobility/vehicle-normalization-issues/${encodeURIComponent(id)}/correct-identity`,
    { method: "POST", body: JSON.stringify(payload) }
  );
}
